const generateFilterOptions = (category) => {

  // Return an array of options for the given category
  return Object.keys(category).map(key => category[key]);
}

export default generateFilterOptions;
